import { NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { PdfUploaderComponent } from './pdf-uploader.component';

@NgModule({
    imports: [
        CommonModule,
        FileUploadModule,
        SharedModule,
    ],
    exports: [PdfUploaderComponent],
    declarations: [PdfUploaderComponent],
    providers: [],
})
export class PdfUploaderModule
{
}
